export default function IsValidDescricao(alocatorEmail) {
  /* alocatorEmail && typeof alocatorEmail === 'string'
    && alocatorEmail.length >= 300; */
  
    var re = /^((([^<>()\[\]\.,;:\s@"]+(\.[^<>()\[\]\.,;:\s@"]+)*)|(".+"))@(([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}))(;(([^<>()\[\]\.,;:\s@"]+(\.[^<>()\[\]\.,;:\s@"]+)*)|(".+"))@(([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}))*$/;

  return re.test(String(alocatorEmail).toLowerCase());
}

